// extracted by mini-css-extract-plugin
export default {"container":"DetailHeader_container__RIZco","hasFooter":"DetailHeader_hasFooter__D4sJK","header":"DetailHeader_header__Uwv-1","buttons":"DetailHeader_buttons__DfKUA"};